import React from 'react';

const input = 'w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm focus:border-emerald-500 outline-none';
const FIELDS = [
  ['services_contract_no', 'Services contract no.'], ['services_description', 'Services description'],
  ['award_amount_usd', 'Award amount (USD)', 'number'], ['award_date', 'Award date', 'date'],
  ['buyer', 'Buyer (email, wallet or name)'], ['seller', 'Seller (blank = you)'],
  ['transferee', 'Transferee (blank = payee)'], ['assignee', 'Assignee'], ['memo', 'Memo'],
];

export const toPayload = (f) => Object.fromEntries(FIELDS.map(([k, , t]) => [k, t === 'number' ? (f[k] ? Number(f[k]) : null) : (f[k] || '').trim()]));

export const PayloadFieldsForm = ({ value, onChange, prefix }) => (
  <div className="mt-3" data-testid={`${prefix}-payload-form`}>
    <p className="text-xs uppercase tracking-wide text-slate-500 mb-2">Payload transmittal · services contract &amp; award · parties</p>
    <div className="grid sm:grid-cols-3 gap-2">
      {FIELDS.map(([k, ph, t]) => (
        <input key={k} type={t || 'text'} value={value[k] || ''} onChange={(e) => onChange({ ...value, [k]: e.target.value })} placeholder={ph}
          title={ph} data-testid={`${prefix}-${k}`} className={input} />
      ))}
    </div>
    <p className="text-[11px] text-slate-500 mt-1">Subscriber emails are filled in automatically with the account name and wallet. Everything here is recorded on-chain with the Treasury reference hash.</p>
  </div>
);
